import { type BasePhone, type PersonPhone, type Phone } from 'services'

export function createBasePhoneWithNullProperties (): BasePhone {
  return {
    id: null,
    addressId: null,
    countryCode: null,
    phoneNumber: '',
    extension: ''
  }
}
export function createPhoneWithNullProperties (): Phone {
  const basePhone = createBasePhoneWithNullProperties()
  return {
    ...basePhone,
    organizationId: null
  }
}
export function createPersonPhoneWithNullProperties (personId?: number): PersonPhone {
  const basePhone = createBasePhoneWithNullProperties()
  return {
    ...basePhone,
    personId
  }
}
